import { InjectionToken } from '@angular/core';

import { BarControlsFeature, BarControlsFeatureKind } from '../../controls/bar-controls.feature';

export type BaasDateTimePickerSettings = {
    /**
     * Whether accepted typed input is reformatted using the picker's display format, immediately and on blur.
     * @experimental Defaults to `false`; a future release may change the default to `true`.
     */
    reformatInputOnAccept: boolean;
};

const DEFAULT_BAAS_DATE_TIME_PICKER_SETTINGS: BaasDateTimePickerSettings = {
    reformatInputOnAccept: false
};

export const BAAS_DATE_TIME_PICKER_SETTINGS = new InjectionToken<BaasDateTimePickerSettings>('BaasDateTimePicker settings', {
    providedIn: 'root',
    factory: () => DEFAULT_BAAS_DATE_TIME_PICKER_SETTINGS
});

/** Configure global date-time picker settings. */
export function withDateTimePickerSettings(settings: Partial<BaasDateTimePickerSettings>): BarControlsFeature {
    return {
        kind: BarControlsFeatureKind.DateTimePickerSettings,
        providers: [
            {
                provide: BAAS_DATE_TIME_PICKER_SETTINGS,
                useValue: { ...DEFAULT_BAAS_DATE_TIME_PICKER_SETTINGS, ...settings }
            }
        ]
    };
}
